import { useCountryContext } from '@archipro-website/localisation';
import heroNz from '../images/hero/hero-nz.webp';
import heroAu from '../images/hero/hero-au.jpg';
import heroUs from '../images/hero/hero-us.jpg';

/**
 * Per-market homepage hero (BC-4479).
 *
 * The hero is a static project banner that differs by market, credited to the
 * featured project. Both the logged-out hero (`HeroSection`) and the logged-in
 * hero (`AiHeroSection`) use the same banner image; only the logged-out hero
 * shows the credit overlay. `href` is a project-detail path resolved on the
 * visitor's own market domain, so a relative path is correct for every market.
 */
export interface HeroMarket {
    /** Full-bleed hero banner photo for the market. */
    image: string;
    featuredProject: {
        name: string;
        architect: string;
        /** Project-detail path (relative — same domain as the visitor). */
        href: string;
    };
}

const NZ: HeroMarket = {
    image: heroNz,
    featuredProject: {
        name: 'Whaitere',
        architect: 'Ponting Fitzgerald Architects',
        href: '/project/whaitere-ponting-fitzgerald-architects',
    },
};

const AU: HeroMarket = {
    image: heroAu,
    featuredProject: {
        name: 'Cape Schanck',
        architect: 'Studio Goss',
        href: '/project/cape-schnack-studio-goss',
    },
};

const US: HeroMarket = {
    image: heroUs,
    featuredProject: {
        name: 'Northshore Residence',
        architect: 'Lucid Architecture',
        href: '/project/northshore-residence-lucid-architecture',
    },
};

/** Resolves the hero banner + featured project for the visitor's market. */
export const useHeroMarket = (): HeroMarket =>
    useCountryContext().byCountry({ NZ, AU, US });
